import { render } from "./FileUploadProgress.vue?vue&type=template&id=3966c168&scoped=true&ts=true"
import script from "./FileUploadProgress.vue?vue&type=script&lang=ts"
export * from "./FileUploadProgress.vue?vue&type=script&lang=ts"

import "./FileUploadProgress.vue?vue&type=style&index=0&id=3966c168&lang=less&rel=stylesheet%2Fless&scoped=true"

import exportComponent from "/Users/yzh-mac/Documents/inm/git/砺成文化/word-admin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3966c168"]])

export default __exports__